import axios from 'axios'

const apiUpdate = axios.create({
  baseURL: 'https://mns.gelogs.co.th/api/update/',
  headers: {
    'Content-Type': 'application/json',
  },
})

apiUpdate.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

export default apiUpdate
